import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import StepTitle from '../StepTitle'
import { IStepProps } from '../../interfaces/Step'
import Step1Form from './Step1Form'
import TooltipWrapper from '../tooltips/TooltipWrapper'
import Step1Tooltip from '../tooltips/Step1Tooltip'
import Step1InfoText from './Step1InfoText'
import Step1FormPeriodicRemediation from './Step1FormPeriodicRemediation'
import { IStore } from '../../interfaces/Store'

function Step1(props: IStepProps): ReactElement {
  const { title } = props

  const { top_jdi } = useSelector(
    (stateReducer: IStore) => stateReducer.folderReducer.folder
  )

  if (top_jdi === '0') {
    return (
      <>
        <StepTitle title={title}>
          <TooltipWrapper
            className="textPrimary"
            title="Pourquoi est-ce important ?"
          >
            <Step1Tooltip />
          </TooltipWrapper>
        </StepTitle>
        <Step1FormPeriodicRemediation {...props} />
      </>
    )
  }

  return (
    <>
      <StepTitle title={title}>
        <TooltipWrapper
          className="textPrimary"
          title="Pourquoi est-ce important ?"
        >
          <Step1Tooltip />
        </TooltipWrapper>
      </StepTitle>
      <div className="row">
        <div className="colLg12">
          <Step1InfoText />
        </div>
      </div>
      <div className="lh2 pt1md">
        <p>Veuillez nous transmettre un justificatif d’identité.</p>
        <p className="mb2">Le document doit être en cours de validité.</p>
      </div>
      <Step1Form {...props} />
    </>
  )
}

export default Step1
